import React, { Component, useState } from 'react';

export const ExportToExcel = (props) => {

    //Open download excel modal
    const onDownloadExcel = (rptId) => {
        props.onDownloadExcel(rptId);
    }    

    return (
        <>
            <div className="card border-secondary mb-3">
                <div className="card-header text-center fw-bold bg-primary text-white">
                    {props.rptName}
                </div>
                <div className="card-body d-flex justify-content-center align-items-center">
                    <button
                        className="btn btn-outline-primary btn-sm d-flex align-items-center gap-2"
                        onClick={() => onDownloadExcel(props.id)}
                    >
                        <i className="fa-solid fa-file-excel"></i>
                        Download File
                    </button>
                </div>
            </div>
            
        </>
    );
}